// 遍历读取该文件夹下全部js文件
const modulesFiles = require.context("./", true, /\.js$/);

const apis = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  if (moduleName === "index") {
    return modules;
  }
  if (moduleName.indexOf("/") === -1) {
    // 一层目录
    modules[moduleName] = modulesFiles(modulePath).default || modulesFiles(modulePath);
  } else {
    // 目前只支持最大深入一级目录
    const moduleNames = moduleName.split("/");
    const [baseName, fileName] = moduleNames;
    if (baseName in modules) {
      modules[baseName][fileName] = modulesFiles(modulePath).default || modulesFiles(modulePath);
    } else {
      modules[baseName] = {};
      modules[baseName][fileName] = modulesFiles(modulePath).default || modulesFiles(modulePath);
    }
  }
  return modules;
}, {});

export const apiInstall = {
  install: Vue => {
    if (apiInstall.installed) {
      return;
    }
    apiInstall.installed = true;
    Object.defineProperties(Vue.prototype, {
      // 注意哦，此处挂载在 Vue 原型的 $api 对象上
      $api: {
        get() {
          return apis;
        }
      }
    });
  }
};
